import { createWebHistory, createRouter, createWebHashHistory } from "vue-router"
import Milkfarm from "@/components/screens/Milkfarm.vue"

const routes = [
  {
    path: "/",
    name: "Milkfarm",
    component: Milkfarm,
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  //history: createWebHashHistory('/gallery/'),
  // @ts-ignore
  routes: routes
})

export default router
